module.exports = __webpack_public_path__ + "img/gift.ca48c8aa.svg";